/* import __COLOCATED_TEMPLATE__ from './ask-for-rating.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    step: $TSFixMe;
    isReadOnly: boolean;
    thatHelpedButtonLabel: string;
    triageButtonLabel: string;
    channelIncompatibleWithFinCSAT: boolean;
    showCsatBlockAfterUpdate: boolean;
    toggleCsatEnabledForHardResolution: () => void;
    toggleCsatEnabledForSoftResolution: () => void;
    toggleRatingChange: () => void;
    setBlockUpdateAfter: (e: InputEvent) => void;
    shouldShowConfirmResolutionSettings: boolean;
    updateCsatCustomMessage?: (content: string) => void;
    onCustomMessageFocus?: () => void;
    toggleUseCsatCustomMessage: () => void; // Function to toggle the use_csat_custom_message field
  };
}

const AskForRating = templateOnlyComponent<Signature>();
export default AskForRating;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::AskForRating': typeof AskForRating;
  }
}
